import { faWordpress } from "@fortawesome/free-brands-svg-icons";
import React from "react";
import FontAwesome from "../../../utility/fontAwesome/fontAwesome";
import direction from "../../../service/direction.json";
const SMSPluginLab = () => {
  return (
    <div className="form-group row col-md-12 text-justify">
      <div className="col-md-6">
        <div style={{ width: "18rem;", fontSize: "20px" }}>
          <div className="card-body">
            <h5 className="card-title text-bold" style={{ fontSize: "30px" }}>
              <FontAwesome icon={faWordpress} style={{ color: "blue" }} />
              آزمایشگاه افزونه پیامک
            </h5>
            <p className="card-text">
              پنل های سایه بان دارای قابلیت وبسرویس API هستند که با استفاده از
              آن میتوانید از سامانه پیامک در وبسایت خود استفاده کنید که برای این
              کار با توجه به نوع اسکریپت و سیستم مدیریت محتوای سایتتان باید
              ماژول پیامک موردنیاز را کدنویسی کنید. ولی سایه بان جهت رفاه
              کاربران ماژول ها و افزونه های پیامکی بسیاری از اسکریپت ها و سیستم
              های کاربردی را آماده کرده و در آزمایشگاه بطور رایگان در اختیار
              عموم گذاشته است.
            </p>
          </div>
        </div>
      </div>
      <div className="col-md-6 text-center">
        <img src={`${direction.ImgDesign}sms-api.png`} alt="سایه بان" />
      </div>
    </div>
  );
};

export default SMSPluginLab;
